import AccessRoles from '../../../../StaticData/Roles/Access';

const RequiredRole = AccessRoles['PROPERTY_MANAGEMENT'];

export default RequiredRole;



// WEBPACK FOOTER //
// ./src/views/Components/Managed/PropertyGroups/StaticData/RequiredRole.tsx